import { render } from "./BaseImageElement.vue?vue&type=template&id=40bcff0c&scoped=true&ts=true"
import script from "./BaseImageElement.vue?vue&type=script&lang=ts"
export * from "./BaseImageElement.vue?vue&type=script&lang=ts"

import "./BaseImageElement.vue?vue&type=style&index=0&id=40bcff0c&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40bcff0c"]])

export default __exports__